import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { map, Observable } from 'rxjs';
import { CustomerDataForPortfolioTransfer, PortfolioTransfer } from '../entities/depot-transfer.entity';
import { HashRequest, HashResponse } from '../entities/hash.entity';
import { MajorelPayload } from '../entities/majorel.entity';

@Injectable({ providedIn: 'root' })
export class DepotTransferInfrastructure {
  private readonly endpoint = `${environment.apihost}/api/portfolio/transfer`;

  constructor(private _http: HttpClient) {}

  public getIsFeatureEnabled(): Observable<boolean> {
    return this._http.get<boolean>(`${this.endpoint}/enabled`);
  }

  public getPortfolioTransfers(): Observable<PortfolioTransfer[]> {
    return this._http.get<PortfolioTransfer[]>(`${this.endpoint}/list`);
  }

  public getBaseData(): Observable<CustomerDataForPortfolioTransfer> {
    return this._http.get<CustomerDataForPortfolioTransfer>(`${this.endpoint}/basedata`);
  }

  public postHash(baseData: CustomerDataForPortfolioTransfer) {
    const data = JSON.stringify(this.createMajorelPayload(baseData));
    const url = `${environment.apihost}/apic/portfoliotransfer/calc-hmac`;
    return this._http.post<HashResponse>(url, new HashRequest(data)).pipe(
      map(({ signature }) => ({
        data,
        signature,
      })),
    );
  }

  private removePrefix(value: string, prefix: string): string {
    return value?.startsWith(prefix) ? value.replace(prefix, '') : value;
  }

  private createMajorelPayload(baseData: CustomerDataForPortfolioTransfer): MajorelPayload {
    const {
      baaderAccIban: Iban,
      firstName: Vorname,
      lastName: Nachname,
      street1: Strasse,
      postalCode: Plz,
      depotId: Depotnummer,
      customerId: Kundennummer,
      city: Ort,
      streetNr: Hausnummer,
      birthdate: Geburtsdatum,
    } = baseData;

    return {
      Iban,
      BLZ: '700 331 00', // baader blz
      Filialnummer: '',
      Depotnummer: this.removePrefix(Depotnummer, 'K'),
      Kundennummer,
      Gemeinschaftskonto: false,
      Kontoinhaber1: {
        Adresse: {
          Plz,
          Ort,
          Strasse,
          Hausnummer,
        },
        Vorname,
        Nachname,
        Geburtsdatum,
        SteuerId: '',
        Steuerpflichtig: false,
      },
    } as MajorelPayload;
  }
}
